// apiAuth.js
// Legger ansatt-tokenet på alle kall til vårt eget API, uten at hvert enkelt
// fetch-kall i appen må gjøre det selv. Kall som allerede har en
// Authorization-header (f.eks. kundeportalen med sin egen token) røres ikke.
import { getToken, logout } from './auth';

const API_BASE = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '');

function isApiUrl(url) {
    return !!API_BASE && typeof url === 'string' && url.startsWith(API_BASE);
}

// fetch() tar imot en streng, et Request-objekt (har .url) eller et URL-objekt
// (har .href, IKKE .url) - mangler denne grenen, faller et kall som
// fetch(new URL(...)) stille gjennom uten Authorization-header, uansett om
// brukeren er innlogget. Reprodusert i Produkter.jsx (hentProdukter), som
// bygger søke-URL-en med `new URL(...)` + `.searchParams.set(...)`.
function urlFraInput(input) {
    if (typeof input === 'string') return input;
    if (typeof URL !== 'undefined' && input instanceof URL) return input.href;
    return input?.url;
}

// Et utløpt/ugyldig ansatt-token gir 401 fra backend. Da logger vi ut og
// sender brukeren til innloggingen, i stedet for at sidene feiler i stillhet.
function handleUnauthorized() {
    if (!getToken()) return;
    logout();
    if (window.location.pathname !== '/login') {
        const from = window.location.pathname + window.location.search;
        window.location.assign(`/login?from=${encodeURIComponent(from)}&reason=expired`);
    }
}

export function installApiAuth() {
    const originalFetch = window.fetch.bind(window);

    window.fetch = async (input, init = {}) => {
        const url = urlFraInput(input);
        const token = getToken();
        if (!token || !isApiUrl(url)) return originalFetch(input, init);

        const headers = new Headers(init.headers || (typeof Request !== 'undefined' && input instanceof Request ? input.headers : undefined));
        let attached = false;
        if (!headers.has('Authorization')) {
            headers.set('Authorization', `Bearer ${token}`);
            attached = true;
        }
        const response = await originalFetch(input, { ...init, headers });
        if (attached && response.status === 401) handleUnauthorized();
        return response;
    };
}
